import {API_URL} from '../constants/index.js';
import {
    BLOCK_FAMILIAR,
    BLOCK_FAMILIAR_SUCCESS,
    BLOCK_FAMILIAR_ERROR
} from '../constants/familiarConstant';
import {sweetAlert} from '../components/Alert/sweetAlert';

//#region BLOCK FAMILIAR

export function blockFamiliar(data) {
    return {
        type: BLOCK_FAMILIAR,
        data
    }
};

export function blockFamiliarSuccess(data) {
    return {
        type: BLOCK_FAMILIAR_SUCCESS,
        data
    }
};

export function blockFamiliarError(data) {
    return {
        type: BLOCK_FAMILIAR_ERROR,
        data
    }
};

export function BlockFamiliar(idFamiliar) {

    return dispatch => {
        dispatch(blockFamiliar());

        fetch(API_URL+'familyMembers/familyMembers/'+ idFamiliar,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                if(res.status===204){
                    const message = `The Familiar has been blocked`

                    dispatch(blockFamiliarSuccess());
    
                    sweetAlert('success',message,'alert_BlockFamilyMenber_Success');
                    return res;
                }
                else if(res.status===404) {

                    const message=res.body.message;
                    dispatch(blockFamiliarError());

                    sweetAlert('error',`An ERROR has occurred while blocking the familiar, ${message}`,'alert_BlockFamilyMenber_Error');
                    return res;
                }
                
            })
            .catch(error => {
                const message = `An ERROR has occurred while blocking the familiar`

                dispatch(blockFamiliarError(error));

                sweetAlert('error',message,'alert_BlockFamilyMenber_Error');

            })
    }
};

//#endregion